<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">HK8 - PENDAPATAN LAIN DIPEROLEH</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        :rules="rules"
        width="20px"
        disabled
      ></v-text-field>

      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>

              <v-spacer></v-spacer>
                <v-btn
                color="error"
                small
                @click="dialogPengesahan=true;"
                >
                  Padam
              </v-btn>

            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataHK8"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
              :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
            >
            <template v-slot:item.INCS22_2= "{ item }">
                 {{ formatNumber(item.INCS22_2) }}
            </template> 
            <template v-slot:item.INCS22_3= "{ item }">
                 {{ formatNumber(item.INCS22_3) }}
            </template>
            <template v-slot:item.INCS22= "{ item }">
                 {{ formatNumber(item.INCS22) }}
             </template>
            <template v-slot:item.S78i= "{ item }">
                 {{ formatNumber(item.S78i) }}
            </template>
            <template v-slot:item.S78ii= "{ item }">
                 {{ formatNumber(item.S78ii) }}
            </template>
            <template v-slot:item.S78iii= "{ item }">
                 {{ formatNumber(item.S78iii) }}
            </template>
            <template v-slot:item.S80= "{ item }">
                 {{ formatNumber(item.S80) }}
            </template>
            <template v-slot:item.INCS23_1= "{ item }">
                 {{ formatNumber(item.INCS23_1) }}
            </template>
            <template v-slot:item.INCS23_2= "{ item }">
                 {{ formatNumber(item.INCS23_2) }}
            </template>
            <template v-slot:item.S84i= "{ item }">
                 {{ formatNumber(item.S84i) }}
            </template>
            <template v-slot:item.S84ii= "{ item }">
                 {{ formatNumber(item.S84ii) }}
            </template>
            <template v-slot:item.S84iii= "{ item }">
                 {{ formatNumber(item.S84iii) }}
            </template>
            <template v-slot:item.INCS23_3= "{ item }">
                 {{ formatNumber(item.INCS23_3) }}
            </template>
            <template v-slot:item.INCS23_4= "{ item }">
                 {{ formatNumber(item.INCS23_4) }}
            </template>
            <template v-slot:item.INCS23= "{ item }">
                 {{ formatNumber(item.INCS23) }}
            </template>
            <template v-slot:item.S86= "{ item }">
                 {{ formatNumber(item.S86) }}
            </template>
            <template v-slot:item.S88= "{ item }">
                 {{ formatNumber(item.S88) }}
            </template>
            <template v-slot:item.S92= "{ item }">
                 {{ formatNumber(item.S92) }}
            </template>
            <template v-slot:item.S90i= "{ item }">
                 {{ formatNumber(item.S90i) }}
            </template>
            <template v-slot:item.S90ii= "{ item }">
                 {{ formatNumber(item.S90ii) }}
            </template>
            <template v-slot:item.INCS32a_1= "{ item }">
                 {{ formatNumber(item.INCS32a_1) }}
            </template>
            <template v-slot:item.INCS32a_2= "{ item }">
                 {{ formatNumber(item.INCS32a_2) }}
            </template>
            <template v-slot:item.INCS32a= "{ item }">
                 {{ formatNumber(item.INCS32a) }}
            </template>
            <template v-slot:item.S94i= "{ item }">
                 {{ formatNumber(item.S94i) }}
            </template>
            <template v-slot:item.S94ii= "{ item }">
                 {{ formatNumber(item.S94ii) }}
            </template>
            <template v-slot:item.S94iii= "{ item }">
                 {{ formatNumber(item.S94iii) }}
            </template>
            <template v-slot:item.INCS32b_1= "{ item }">
                 {{ formatNumber(item.INCS32b_1) }}
            </template>
            <template v-slot:item.INCS32b_2= "{ item }">
                 {{ formatNumber(item.INCS32b_2) }}
            </template>
            <template v-slot:item.INCS32b= "{ item }">
                 {{ formatNumber(item.INCS32b) }}
            </template>
            <template v-slot:item.INCS31= "{ item }">
                 {{ formatNumber(item.INCS31) }}
            </template>
            <template v-slot:item.INCS33= "{ item }">
                 {{ formatNumber(item.INCS33) }}
            </template>
            <template v-slot:item.INCS34= "{ item }">
                 {{ formatNumber(item.INCS34) }}
            </template>
            <template v-slot:item.INCS32= "{ item }">
                 {{ formatNumber(item.INCS32) }}
            </template>

          </v-data-table>
      </v-card>   
    </v-card> 

<v-card>
  <v-card-title>
    Pendapatan lain diperoleh
  </v-card-title>

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <!-- s75 -->
      <v-row>
        <v-col>
        S75 : Adakah anda/ahli isi rumah memiliki tempat kediaman ini?
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="S75"
            @change="changeS75"
            style="width: 400px"
        ></v-select>
        </v-col>
      </v-row>

      <!-- s76 -->
    <div v-show="showS76">
      
      <v-row >
        <v-col>
        S76 : Apakah jenis rumah anda atau ahli isi rumah? <strong>[INCS22.1]</strong>
        <v-autocomplete
            :items='JenisRumah'
            item-text="desc"
            return-object
            solo
            dense
            v-model="INCS22_1"
            style="width: 400px"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s77 -->
      <v-col>
         S77 : Nyatakan jumlah kasar sewa tahunan sekiranya anda/ahli isi rumah menyewakan tempat kediaman ini (Setahun) <strong>[INCS22.2]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS22_2"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 400px"
                      @keypress="limitDigits"
                ></v-text-field>
                 </v-col>
             </v-row>
      </v-col>

      <!-- s78 -->
      <v-col>
          S78 : Jumlah perbelanjaan tahunan
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) Pembaikan dan penyelenggaraan (Setahun)
                <v-text-field
                      v-model="S78i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 400px"
                      @keypress="limitDigits"
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Cukai Tanah (Setahun)
                 <v-text-field
                      v-model="S78ii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 400px"
                      @keypress="limitDigits"
                     
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (iii) Cukai Pintu (Setahun)
                 <v-text-field
                      v-model="S78iii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      style="width: 400px"
                      @keypress="limitDigits"
                       
                ></v-text-field>
               
              </v-col>
              <v-col cols="4" sm="6" md="4">
                Jumlah perbelanjaan tahunan <strong>[INCS22.3]</strong>
                <!-- s78i+s78ii+s78ii -->
                <v-text-field
                      v-model="INCS22_3"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 400px"
                      @keypress="limitDigits"
                     
                ></v-text-field>
               
              </v-col>
          </v-row>
      </v-col>
  
      <!-- s79 -->
      <v-row>
        <v-col>
         S79 : Jumlah sewa bersih tahunan <strong>[INCS22]</strong>
         <!-- incs22_2 - incs22_3 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS22"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                      style="width: 400px"
                      @keypress="limitDigits"
                      
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row>
    </div>

    <!-- s80 -->
    <v-row>
        <v-col>
        S80 : Adakah anda memiliki rumah/ harta lain yang disewakan?
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="S80"
            @change="changeS80"
            style="width: 400px"
        ></v-select>
        </v-col>
    </v-row>
    
    <!-- s81 -->
    <div v-show="showS81">
      <v-row>
        <v-col> 
              S81 : Apakah jenis rumah/ harta lain yang anda sewakan? <strong>[INCS23.1]</strong>
              <v-select
                  :items='JenisRumah'
                  item-text="desc"
                  return-object
                  solo
                  dense
                  v-model="INCS23_1"
                  style="width: 400px"
              ></v-select>
        </v-col>
      </v-row>
      
      <!-- s82 -->
      <v-row>
        <v-col cols="6">
         S82 : Nyatakan bilangan rumah/ harta lain <strong>[INCS23.2]</strong>
        <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS23_2"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row>
      
      <!-- s83 -->
      <v-row>
        <v-col cols="6">
          S83 : Nyatakan jumlah kasar sewa tahunan bagi rumah/ harta lain yang disewakan <strong>[INCS23.3]</strong>
        <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS23_3"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                       
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row>
      
      <!-- s84 -->
      <v-row>
        <v-col>
          S84 : Jumlah perbelanjaan tahunan
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) Pembaikan dan penyelenggaraan (Setahun)
                <v-text-field
                      v-model="S84i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Cukai Tanah (Setahun)
                 <v-text-field
                      v-model="S84ii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                         
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (iii) Cukai Pintu (Setahun)
                 <v-text-field
                      v-model="S84iii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                         
                ></v-text-field>
               
              </v-col>
              <v-col cols="4" sm="6" md="4">
                Jumlah perbelanjaan tahunan <strong>[INCS23.4]</strong>
                <!-- s84i+s84ii+s84iii -->
                <v-text-field
                      v-model="INCS23_4"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
               
              </v-col>
          </v-row>
        </v-col>
      </v-row>
      
      <!-- s85 -->
      <v-row>
        <v-col>
         S85 : Jumlah sewa bersih tahunan <strong>[INCS23]</strong>
         <!-- incs23_3-incs23_4 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS23"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row>
    </div>

    <!-- s86 -->
    <v-row>
        <v-col>
         S86 : Adakah anda menyewakan sebahagian daripada tempat kediaman anda?
         (cth: sewa bilik di tempat kediaman anda)
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="S86"
            @change="changeS86"
             style="width: 400px"
        ></v-select>
        </v-col>
    </v-row>
    
    <!-- s87 -->
    <div v-show="showS87">
      <v-row >
        <v-col>
         S87 : Nyatakan jumlah kasar sewa tahunan daripada tempat menginap <strong>[INCS24]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS24"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                      
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row> 
    </div>

    <v-card-title>
    <v-strong>Pendapatan daripada harta</v-strong>
    </v-card-title>
    
    <!-- s88 -->
    <v-row>
        <v-col>
       S88. Adakah anda menyewakan tanah pertanian yang anda miliki?
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="S88"
            @change="changeS88"
             style="width: 400px"
        ></v-select>
        </v-col>
    </v-row>
    
    <!-- s89 -->
  <div v-show="showS89">
      <v-row>
        <v-col>
         S89. Nyatakan jumlah kasar sewa tahunan daripada tanah pertanian yang disewakan <strong>[INCS32a.1]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS32a_1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                       
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row> 
      
      <!-- s90 -->
      <v-row>
        <v-col>
          S90. Jumlah perbelanjaan tahunan
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) penyelenggaraan (Setahun)
                <v-text-field
                      v-model="S90i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Cukai Tanah (Setahun)
                 <v-text-field
                      v-model="S90ii" 
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
              </v-col>
              
              <v-col cols="4" sm="6" md="4">
                Jumlah perbelanjaan tahunan <strong>[INCS32a.2]</strong>
                <!-- s90i+s90ii -->
                <v-text-field
                      v-model="INCS32a_2"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
                </v-col>
          </v-row>
        </v-col>
      </v-row>
     
      <!-- s91 -->
      <v-row>
        <v-col>
         S91. Jumlah sewa bersih tahunan <strong>[INCS32a]</strong>
         <!-- incs32a_1 - incs32a_2 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS32a"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                        
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row> 
  </div>

      <v-row>


        
        <v-col>
         S92. Adakah anda menyewakan tanah bukan pertanian yang anda miliki? 
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="S92"
            @change="changeS92"
             style="width: 400px"
        ></v-select>
        </v-col>
      </v-row>
  
  <!-- s93 -->
  <div v-show="showS93">
      <v-row>
        <v-col>
         S93. Nyatakan jumlah kasar sewa tahunan daripada tanah bukan pertanian yang disewakan <strong>[INCS32b.1]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS32b_1"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                       
                ></v-text-field>
                 </v-col>
            </v-row>
        </v-col>
      </v-row> 
      
      <!-- s94 -->
      <v-row>
        <v-col>
          S94. Jumlah perbelanjaan tahunan 
          <v-row>
              <v-col cols="4" sm="6" md="4">
                (i) penyelenggaraan (Setahun)
                <v-text-field
                      v-model="S94i"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                         
                ></v-text-field>
              </v-col>

              <v-col cols="4" sm="6" md="4">
                (ii) Cukai Tanah (Setahun)
                 <v-text-field
                      v-model="S94ii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                       
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="4">
                (iii) Cukai Pintu (Setahun)
                 <v-text-field
                      v-model="S94iii"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                         
                ></v-text-field>
               
              </v-col>
              <v-col cols="4" sm="6" md="4">
                Jumlah perbelanjaan tahunan <strong>[INCS32b.2]</strong>
                <!-- s94i+s94ii+s94iii -->
                <v-text-field
                      v-model="INCS32b_2"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                      
                ></v-text-field>
               
              </v-col>
          </v-row>
        </v-col>
      </v-row>
      
      <!-- s95 -->
      <v-row>
        <v-col>
         S95. Jumlah sewa bersih tahunan <strong>[INCS32b]</strong>
         <!-- incs32b_1 - incs32b_2 -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS32b"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                        
             ></v-text-field>
             </v-col>
            </v-row>
        </v-col>
      </v-row> 
     
  
      
      <v-row>
        <v-col>
         Jumlah sewa tanah pertanian dan bukan pertanian <strong>[INCS32]</strong>
         <!-- incs32a + incs32b -->
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS32"
                      label="RM"
                      outlined
                      type="number"
                      dense
                      disabled
                       style="width: 400px"
                       @keypress="limitDigits"
                        
             ></v-text-field>
             </v-col>
            </v-row>
        </v-col>
      </v-row> 
    </div>
      <!-- s96 -->
      <v-row>
        <v-col>
         S96. Nyatakan jumlah royalti yang diterima dalam 12 bulan yang lalu
          (cth: hak cipta, paten dan hak yang serupa) <strong>[INCS31]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS31"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                       
             ></v-text-field>
             </v-col>
           </v-row>
        </v-col>
      </v-row> 
      
      <!-- s97 -->
      <v-row>
        <v-col>
         S97. Nyatakan jumlah faedah yang diterima dalam 12 bulan yang lalu
         (cth: deposit bank, pinjaman, dll.) <strong>[INCS33]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS33"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                         
            ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row> 
      
      <!-- s98 -->
      <v-row>
        <v-col>
          S98. Nyatakan jumlah dividen yang diterima dalam 12 bulan yang lalu
           (cth: hak milik saham, saham amanah, dll.) <strong>[INCS34]</strong>
          <v-row>
            <v-col cols="4" sm="6" md="4">
            <v-text-field
                      v-model="INCS34"
                      label="RM"
                      outlined
                      type="number"
                      dense
                       style="width: 400px"
                       @keypress="limitDigits"
                         
            ></v-text-field>
              </v-col>
            </v-row>
        </v-col>
      </v-row> 
    </v-form>
  </v-card-text>

<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        :disabled="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK8()"
    >
      Kemaskini
    </v-btn>
     <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('1')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?                                         
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<!-- <v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog> -->


<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
            
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    // props:['data'],
    async beforeMount(){
        //this.getUnits('ayam')
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();
        this.JenisRumah = lookupFieldServices.getJenisRumah();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        

        this.getData();//dapatkan data based on HID


    },
    data: () => ({
        updateButton: true,
        saveButton: false,
        butangSimpan: true,
        butangKemaskini: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        kemaskiniDialog: false,
        dialogPengesahan:false,

        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        JenisRumah:[],
        showS76 : false,
        showS81 : false,
        showS87 : false,
        showS89 : false,
        showS93 : false,

        /////////////////////data declaration//////////////////////////

        HID: '',
        //KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,

        S75:'',
        INCS22_1:0,
        INCS22_2:0,
        // INCS22_3:0,
        // INCS22:0,
        S78i:0,
        S78ii:0,
        S78iii:0,
        S80:'',
        INCS23_1:0,
        INCS23_2:0,
        S84i:0,
        S84ii:0,
        S84iii:0,
        INCS23_3:0,
        // INCS23_4:0,
        // INCS23:0,
        S86:'',
        INCS24:0,
        S88:'',
        S92:'',
        S90i:0,
        S90ii:0,
        INCS32a_1:0,
        // INCS32a_2:0,
        // INCS32a:0,
        S94i:0,
        S94ii:0,
        S94iii:0,
        INCS32b_1:0,
        // INCS32b_2:0,
        // INCS32b:0,
         INCS31:0,
         INCS33:0,
         INCS34:0,
        // INCS32:0,

        dataHK8: [],
        rules: [
        value => !!value || 'Required.',
        ],
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID', value: 'HID' },
          { text: 'S75', value: 'S75' },
          { text: 'INCS22.1', value: 'INCS22_1' },
          { text: 'INCS22.2', value: 'INCS22_2' },
          { text: 'INCS22.3', value: 'INCS22_3' },
          { text: 'INCS22', value: 'INCS22' },
          { text: 'S78(i)', value: 'S78i' },
          { text: 'S78(ii)', value: 'S78ii' },
          { text: 'S78(iii)', value: 'S78iii' },
          { text: 'S80', value: 'S80' },
          { text: 'INCS23.1', value: 'INCS23_1' },
          { text: 'INCS23.2', value: 'INCS23_2' },
          { text: 'S84(i)', value: 'S84i' },
          { text: 'S84(ii)', value: 'S84ii' },
          { text: 'S84(iii)', value: 'S84iii' },
          { text: 'INCS23.3', value: 'INCS23_3' },
          { text: 'INCS23.4', value: 'INCS23_4' },
          { text: 'INCS23', value: 'INCS23' },
          { text: 'S86', value: 'S86' },
          { text: 'INCS24', value: 'INCS24' },
          { text: 'S88', value: 'S88' },
          { text: 'S92', value: 'S92' },
          { text: 'S90(i)', value: 'S90i' },
          { text: 'S90(ii)', value: 'S90ii' },
          { text: 'INCS32a.1', value: 'INCS32a_1' },
          { text: 'INCS32a.2', value: 'INCS32a_2' },
          { text: 'INCS32a', value: 'INCS32a' },
          { text: 'S94(i)', value: 'S94i' },
          { text: 'S94(ii)', value: 'S94ii' },
          { text: 'S94(iii)', value: 'S94iii' },
          { text: 'INCS32b.1', value: 'INCS32b_1' },
          { text: 'INCS32b.2', value: 'INCS32b_2' },
          { text: 'INCS32b', value: 'INCS32b' },
          { text: 'INCS32', value: 'INCS32' },
          { text: 'INCS31', value: 'INCS31' },
          { text: 'INCS33', value: 'INCS33' },
          { text: 'INCS34', value: 'INCS34' },
          
          
          //{ text: 'HKI Pendapatan', value: 'PENHK1' },
        ],
       ///////////link untuk ke page/////////////////////
       breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'HK8',
          disabled: true,
          href: 'hk8',
        },
      ],
      // breadcrumbs: [
      //   {
      //     text: 'Ringkasan Ahli Isi Rumah',
      //     disabled: false,
      //     href: '/paparanutama',
      //   },
      //   {
      //     text: 'HK1',
      //     disabled: true,
      //     href: 'hk1',
      //   },
      //   {
      //     text: 'HK2',
      //     disabled: true,
      //     href: 'hk2',
      //   },
      //     {
      //     text: 'HK3',
      //     disabled: true,
      //     href: 'hk3',
      //   },
      //     {
      //     text: 'HK4',
      //     disabled: true,
      //     href: 'hk4',
      //   },
      //     {
      //     text: 'HK5',
      //     disabled: true,
      //     href: 'hk5',
      //   },
      //     {
      //     text: 'HK6',
      //     disabled: true,
      //     href: 'hk6',
      //   },
      //     {
      //     text: 'HK7',
      //     disabled: true,
      //     href: 'hk7',
      //   },
      //   {
      //     text: 'HK8',
      //     disabled: true,
      //     href: 'hk8',
      //   },
         
      // ],
      valid: true,
      select: null,
      checkbox: false,
    }),

    methods: {
      getUnits: function(a) {
            alert(`${a}`)
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
      formatNumber(value) {
    // Treat 0 as a special case to display 0 in the data table
        if (value === 0) {
            return '0';
        } else if (value === null) {
            return ''; // Treat null values as empty strings for consistency
        } else if (typeof value !== 'string') {
            value = String(value); // Convert non-string values to string
        }
        // Check if value is empty or not
        if (value.trim() === '') {
            return '';
        }
        // Perform the replace operation to format the number with commas
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    stripCommas(value) {
    // Check if value is a string before replacing commas
    if (typeof value !== 'string') {
        return value; // Return value unchanged if it's not a string
    }
    return value.replace(/,/g, '');
    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      changeS75(val){
        var valueS75 = val.id;
        if(valueS75 == 1){
          this.showS76 = true;
        }
        if(valueS75 == 2){
          this.showS76 = false;
          this.INCS22_1 = {"id":0};
          this.INCS22_2 = 0;
          this.INCS22_3 = 0;
          this.S78i = 0;
          this.S78ii = 0;
          this.S78iii = 0;
          this.INCS22 = 0;
        }

      },
      changeS80(val){
        var valueS80 = val.id;
        if(valueS80 == 1){
          this.showS81 = true;
        }
        if(valueS80 == 2){
          this.showS81 = false;
          this.INCS23_1 = this.JenisRumah[0];
          this.INCS23_2 = 0;
          this.INCS23_3 = 0;
          this.S84i = 0;
          this.S84ii = 0;
          this.S84iii = 0;
          this.INCS23 = 0;
        }

      },
      changeS86(val){
        var valueS86 = val.id;
        if(valueS86 == 1){
          this.showS87 = true;
        }
        if(valueS86 == 2){
          this.showS87 = false;
          this.INCS24 = 0;
        }

      },
      changeS88(val){
        var valueS88 = val.id;
        if(valueS88 == 1){
          this.showS89 = true;
        }
        if(valueS88 == 2){
          this.showS89 = false;
          this.S90i = 0;
          this.S90ii = 0;
          this.INCS32a_1 = 0;
          this.INCS32a_2 = 0;
          this.INCS32a = 0;
         this.INCS32 = 0;
        }

      },
      changeS92(val){
        var valueS92 = val.id;
        if(valueS92 == 1){
          this.showS93 = true;
        }
        if(valueS92 == 2){
          this.showS93 = false;
          this.INCS32b_1 =  0;
          this.S94i = 0;
          this.S94ii = 0;
          this.S94iii = 0;
          this.INCS32b = 0;
          this.INCS32 = 0;
        }

      },
      async simpan (){
      
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {

                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK8`, {
                
                HID:  this.HID,
                NOAIR: this.NOAIR,
                S75: this.S75.id, 
                INCS22_1: this.INCS22_1.id,
                INCS22_2: this.INCS22_2 === null ? '0' : this.stripCommas(this.INCS22_2),
                INCS22_3: this.INCS22_3 === null ? '0' : this.stripCommas(this.INCS22_3),
                INCS22: this.INCS22 === null ? '0' : this.stripCommas(this.INCS22),
                S78i: this.S78i === null ? '0' : this.stripCommas(this.S78i),
                S78ii: this.S78ii === null ? '0' : this.stripCommas(this.S78ii),
                S78iii: this.S78iii === null ? '0' : this.stripCommas(this.S78iii),
                S80: this.S80.id,
                INCS23_1: this.INCS23_1.id,
                INCS23_2: this.INCS23_2,
                S84i: this.S84i === null ? '0' : this.stripCommas(this.S84i),
                S84ii: this.S84ii === null ? '0' : this.stripCommas(this.S84ii),
                S84iii: this.S84iii === null ? '0' : this.stripCommas(this.S84iii), 
                INCS23_3: this.INCS23_3 === null ? '0' : this.stripCommas(this.INCS23_3),
                INCS23_4: this.INCS23_4 === null ? '0' : this.stripCommas(this.INCS23_4),
                INCS23: this.INCS23 === null ? '0' : this.stripCommas(this.INCS23),
                S86: this.S86.id,
                INCS24: this.INCS24 === null ? '0' : this.stripCommas(this.INCS24),
                S88: this.S88.id,
                S92: this.S92.id,
                S90i: this.S90i === null ? '0' : this.stripCommas(this.S90i),
                S90ii: this.S90ii === null ? '0' : this.stripCommas(this.S90ii),
                INCS32a_1: this.INCS32a_1 === null ? '0' : this.stripCommas(this.INCS32a_1),
                INCS32a_2: this.INCS32a_2 === null ? '0' : this.stripCommas(this.INCS32a_2),
                INCS32a: this.INCS32a === null ? '0' : this.stripCommas(this.INCS32a),
                S94i: this.S94i === null ? '0' : this.stripCommas(this.S94i),
                S94ii: this.S94ii === null ? '0' : this.stripCommas(this.S94ii),
                S94iii: this.S94iii === null ? '0' : this.stripCommas(this.S94iii),
                INCS32b_1: this.INCS32b_1 === null ? '0' : this.stripCommas(this.INCS32b_1),
                INCS32b_2: this.INCS32b_2 === null ? '0' : this.stripCommas(this.INCS32b_2),
                INCS32b: this.INCS32b === null ? '0' : this.stripCommas(this.INCS32b),
                INCS31: this.INCS31 === null ? '0' : this.stripCommas(this.INCS31),
                INCS33: this.INCS33 === null ? '0' : this.stripCommas(this.INCS33),
                INCS34: this.INCS34 === null ? '0' : this.stripCommas(this.INCS34),
                INCS32: this.INCS32 === null ? '0' : this.stripCommas(this.INCS32),
                
              })
                this.res = res.data;
                this.reset();
                //console.log(this.res)
                this.getData();
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = true;
                // this.successMessage = 'Data Disimpan!';
                // this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                // this.reset();
                // this.getData();
                // window.scrollTo(0, 0);
                // console.log(this.INCS32)
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
       async updateHK8(){
          
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK8`, {
                
                HID:  this.HID,
                NOAIR: this.NOAIR,
                S75: this.S75.id, 
                INCS22_1: this.INCS22_1.id,
                INCS22_2: this.INCS22_2,
                INCS22_3: this.INCS22_3,
                INCS22: this.INCS22,
                S78i: this.S78i,
                S78ii: this.S78ii,
                S78iii: this.S78iii,
                S80: this.S80.id,
                INCS23_1: this.INCS23_1.id,
                INCS23_2: this.INCS23_2,
                S84i: this.S84i,
                S84ii: this.S84ii,
                S84iii: this.S84iii, 
                INCS23_3: this.INCS23_3,
                INCS23_4: this.INCS23_4,
                INCS23: this.INCS23,
                S86: this.S86.id,
                INCS24: this.INCS24,
                S88: this.S88.id,
                S92: this.S92.id,
                S90i: this.S90i,
                S90ii: this.S90ii,
                INCS32a_1: this.INCS32a_1,
                INCS32a_2: this.INCS32a_2,
                INCS32a: this.INCS32a,
                S94i: this.S94i,
                S94ii: this.S94ii,
                S94iii: this.S94iii,
                INCS32b_1: this.INCS32b_1,
                INCS32b_2: this.INCS32b_2,
                INCS32b: this.INCS32b,
                INCS31: this.INCS31,
                INCS33: this.INCS33,
                INCS34: this.INCS34,
                INCS32: this.INCS32,

              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = false;
                // this.butangKemaskini = false;
                // this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                // this.successMessage = 'Data Dikemaskini!';
                // this.reset();
                // this.getData();
                // window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }  
      },
      async padam(val){
        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
          try {
              ///////////tunjukkan alert padam////////////
              this.popUpALert = false;
                ////send delete to API///////
              if (this.$refs.form.validate()){
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK8/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Deleted!'
                this.saveButton = false;
                this.updateButton = true;
                this.reset();
                this.getData(); 
              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = "Please Fill In the field"
              }
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
        }
        else if(val == 2){
          this.popUpALert = false;
        }
          
      },
      async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK8"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 1000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
      async getData(){
        //dapatkan data dari table HK1 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK8?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.dataHK8 = dataz;
            console.log(this.dataHK8)
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {
           this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.saveButton = true;
          this.updateButton = false;
          this.butangKemaskini = true;
          this.butangSimpan = false;
          this.NOAIR = row.NOAIR;
          this.Bil = row.Bil;
          this.S75 = row.S75;
          this.INCS22_1 = row.INCS22_1;
          this.INCS22_2 = this.stripCommas(row.INCS22_2);
          this.INCS22_3 = this.stripCommas(row.INCS22_3);
          this.INCS22 = this.stripCommas(row.INCS22);
          this.S78i = this.stripCommas(row.S78i);
          this.S78ii = this.stripCommas(row.S78ii);
          this.S78iii = this.stripCommas(row.S78iii);
          this.S80 = this.stripCommas(row.S80);
          this.INCS23_1 = this.stripCommas(row.INCS23_1);
          this.INCS23_2 = this.stripCommas(row.INCS23_2);
          this.S84i = this.stripCommas(row.S84i);
          this.S84ii = this.stripCommas(row.S84ii);
          this.S84iii = this.stripCommas(row.S84iii);
          this.INCS23_3 = this.stripCommas(row.INCS23_3);
          this.INCS23_4 = this.stripCommas(row.INCS23_4);
          this.INCS23 = this.stripCommas(row.INCS23);
          this.S86 = this.stripCommas(row.S86);
          this.S88 = this.stripCommas(row.S88);
          this.S92 = this.stripCommas(row.S92);
          this.S90i = this.stripCommas(row.S90i);
          this.S90ii = this.stripCommas(row.S90ii);
          this.INCS32a_1 = this.stripCommas(row.INCS32a_1);
          this.INCS32a_2 = this.stripCommas(row.INCS32a_2);
          this.INCS32a = this.stripCommas(row.INCS32a);
          this.S94i = this.stripCommas(row.S94i);
          this.S94ii = this.stripCommas(row.S94ii);
          this.S94iii = this.stripCommas(row.S94iii);
          this.INCS32b_1 = this.stripCommas(row.INCS32b_1);
          this.INCS32b_2 = this.stripCommas(row.INCS32b_2);
          this.INCS32b = this.stripCommas(row.INCS32b);
          this.INCS31 = this.stripCommas(row.INCS31);
          this.INCS33 = this.stripCommas(row.INCS33);
          this.INCS34 = this.stripCommas(row.INCS34);
          this.INCS32 = this.stripCommas(row.INCS32);

          // or just do something with your current clicked row item data
          //console.log(row)

        // .......SOALAN YA/TIDAK....12/12/2022.........
          // if(row.S75 == 1){
          //   this.S75 = this.yaTidak[0];
          // }
          // if(row.S75 == 2){
          //   this.S75 = this.yaTidak[1];
          // }
          this.S75 = this.yaTidak[Number(row.S75) - 1];
          if(row.S75 == 1){
            this.showS76 = true;
              if(row.INCS22_1 == 1){
              this.INCS22_1 = this.JenisRumah[0];
              }
              if(row.INCS22_1 == 2){
                this.INCS22_1 = this.JenisRumah[1];
              }
              if(row.INCS22_1 == 3){
              this.INCS22_1 = this.JenisRumah[2];
              }
              if(row.INCS22_1 == 4){
              this.INCS22_1 = this.JenisRumah[3];
              }
              if(row.INCS22_1 == 5){
                this.INCS22_1 = this.JenisRumah[4];
              }
              if(row.INCS22_1 == 6){
                this.INCS22_1 = this.JenisRumah[5];
              }
              if(row.INCS22_1 == 7){
                this.INCS22_1 = this.JenisRumah[6];
              }
              if(row.INCS22_1 == 8){
                this.INCS22_1 = this.JenisRumah[7];
              }
              if(row.INCS22_1 == 9){
                this.INCS22_1 = this.JenisRumah[8];
              }
              if(row.INCS22_1 == 10){
                this.INCS22_1 = this.JenisRumah[9];
              }
              if(row.INCS22_1 == 11){
                this.INCS22_1 = this.JenisRumah[10];
              }
              if(row.INCS22_1 == 12){
                this.INCS22_1 = this.JenisRumah[11];
              }
              if(row.INCS22_1 == 13){
                this.INCS22_1 = this.JenisRumah[12];
              }
              if(row.INCS22_1 == 14){
                this.INCS22_1= this.JenisRumah[13];
              }
              if(row.INCS22_1 == 15){
                this.INCS22_1 = this.JenisRumah[14];
              }
              if(row.INCS22_1 == 16){
                this.INCS22_1= this.JenisRumah[15];
              }
              if(row.INCS22_1 == 17){
                this.INCS22_1 = this.JenisRumah[16];
              }
              if(row.INCS22_1 == 18 ){
                this.INCS22_1 = this.JenisRumah[17];
              }

              //this.INCS22_1 = this.JenisRumah[0];
               //this.JRR = this.JenisRumah[2];
              //this.INCS22_1 = this.JenisRumah[row.INCS22_1];

            }

          this.S80 = this.yaTidak[Number(row.S80) - 1];
          if(row.S80 == 1){
            this.showS81 = true;
            if(row.INCS23_1 == 1){
              this.INCS23_1 = this.JenisRumah[0];
              }
              if(row.INCS23_1 == 2){
                this.INCS23_1 = this.JenisRumah[1];
              }
              if(row.INCS23_1 == 3){
              this.INCS23_1 = this.JenisRumah[2];
              }
              if(row.INCS23_1 == 4){
              this.INCS23_1 = this.JenisRumah[3];
              }
              if(row.INCS23_1 == 5){
                this.INCS23_1 = this.JenisRumah[4];
              }
              if(row.INCS23_1 == 6){
                this.INCS23_1 = this.JenisRumah[5];
              }
              if(row.INCS23_1 == 7){
                this.INCS23_1 = this.JenisRumah[6];
              }
              if(row.INCS23_1 == 8){
                this.INCS23_1 = this.JenisRumah[7];
              }
              if(row.INCS23_1 == 9){
                this.INCS23_1 = this.JenisRumah[8];
              }
              if(row.INCS23_1 == 10){
                this.INCS23_1 = this.JenisRumah[9];
              }
              if(row.INCS23_1 == 11){
                this.INCS23_1 = this.JenisRumah[10];
              }
              if(row.INCS23_1 == 12){
                this.INCS23_1 = this.JenisRumah[11];
              }
              if(row.INCS23_1 == 13){
                this.INCS23_1 = this.JenisRumah[12];
              }
              if(row.INCS23_1 == 14){
                this.INCS23_1= this.JenisRumah[13];
              }
              if(row.INCS23_1 == 15){
                this.INCS23_1 = this.JenisRumah[14];
              }
              if(row.INCS23_1 == 16){
                this.INCS23_1= this.JenisRumah[15];
              }
              if(row.INCS23_1 == 17){
                this.INCS23_1 = this.JenisRumah[16];
              }
              if(row.INCS23_1 == 18 ){
                this.INCS23_1 = this.JenisRumah[17];
              }
              // this.INCS23_1 = this.JenisRumah[row.INCS23_1];
            }

          this.S86 = this.yaTidak[Number(row.S86) - 1];
          if(row.S86 == 1){
            this.showS87 = true;
            this.INCS24 = row.INCS24;
            }

          this.S88 = this.yaTidak[Number(row.S88) - 1];
          if(row.S88 == 1){
            this.showS89 = true;
            this.INCS32a_1 = row.INCS32a_1;
            }

          this.S92 = this.yaTidak[Number(row.S92) - 1];
          if(row.S92 == 1){
            this.showS93 = true;
            this.INCS32b_1 = row.INCS32b_1;
            }
    

      },
      goTo(option){
        
        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
          
          if(this.NOAIR == "01"){
            this.$router.push({name: "JRBpindahan"});
          }
          else{
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
         
        }   
      }
    },
  computed:{
    INCS22_3: function(){
      var total = 0;
        total = Number(total) + Number(this.S78i)  + Number(this.S78ii) + Number(this.S78iii);
      return total;
    },
     INCS22: function(){
      var total = 0;
        total = Number(this.INCS22_2)  - Number(this.INCS22_3);
      return total;
    },
    INCS23_4: function(){
      var total = 0;
        total = Number(total) + Number(this.S84i)  + Number(this.S84ii) + Number(this.S84iii)   ;
      return total;
    },
    INCS23: function(){
      var total = 0;
        total = Number(this.INCS23_3)  - Number(this.INCS23_4);
      return total;
    },
    INCS32a_2: function(){
      var total = 0;
        total = Number(total) + Number(this.S90i)  + Number(this.S90ii);
      return total;
    },
     INCS32a: function(){
      var total = 0;
        total = Number(this.INCS32a_1)  - Number(this.INCS32a_2);
      return total;
    },
    INCS32b_2: function(){
      var total = 0;
        total = Number(total) + Number(this.S94i)  + Number(this.S94ii) + Number(this.S94iii);
      return total;
    },
    INCS32b: function () {
      var total = 0;
      total = Number(this.INCS32b_1) - Number(this.INCS32b_2);
      return total;
    },
    INCS32: function () {
      var total = 0;
      total = Number(this.INCS32a) + Number(this.INCS32b);
      return total;
    },
    schemeRule() {
      return schemeRule;
    },
  },
  watch:{ 
    dataHK8(){
      if(this.dataHK8.length > 0){
        this.butangSimpan = true;
        
      }else{
        this.butangSimpan = false;
       
      }
    }
      // S75(){
        
      //   if(this.S75.id == 1){
      //     this.showS76 = true;
      //   }else{
      //     this.showS76 = false;
      //   }

      // },
      // S80(){
      //   if(this.S80.id == 1){
      //     this.showS81 = true
      //   }
      //   else{
      //     this.showS81 = false
      //   }
        
      // },
      // S86(){
      //   if(this.S86.id == 1){
      //     this.showS87 = true
      //   }
      //   else{
      //      this.showS87 = false
      //   }
        
        
      // },
      // S88(){
      //   if(this.S88.id == 1){
      //     this.showS89 = true
      //   }
      //   else{
      //      this.showS89 = false
      //   }
        
        
      // },
      // S92(){
      //   if(this.S92.id == 1){
      //     this.showS93 = true
      //   }
      //   else{
      //      this.showS93 = false
      //   }
      // },
    //   S78iii(){
    //     this.INCS22_3 = Number(this.S78i) + Number(this.S78ii) + Number(this.S78iii);
    //   },
    //   INCS22_3(){
    //     this.INCS22 = Number(this.INCS22_2) - Number(this.INCS22_3);
    //   },
    //   S84iii(){
    //     this.INCS23_4 = Number(this.S84i) + Number(this.S84ii) + Number(this.S84iii);
    //   },
    //   INCS23_4(){
    //     this.INCS23 = Number(this.INCS23_3) - Number(this.INCS23_4);
    //   },
    //   S90ii(){
    //     this.INCS32a_2 = Number(this.S90i) + Number(this.S90ii);
    //   },
    //   INCS32a_2(){
    //     this.INCS32a = Number(this.INCS32a_1) - Number(this.INCS32a_2);
    //   },
    //  S94iii(){
    //     this.INCS32b_2 = Number(this.S94i) + Number(this.S94ii) + Number(this.S94iii);
    //   },
    //   INCS32b_2(){
    //     this.INCS32b = Number(this.INCS32b_1) - Number(this.INCS32b_2);
    //   },
  }
}
</script>
